export default {
  content: {
    height: "100%",
    paddingLeft: 16,
    paddingRight: 16
  }
}